import React from 'react'

import AvailableDomain from 'app/components/SVGS/AvailableDomain'
import { IOnboardingChecklistProps } from './interface'
import OnboardingChecklistItems from './OnboardingChecklistItems'
// @ts-ignore
import { MAX_TABLET_DEVICE_WIDTH } from 'app/constants/screenSizes'
import { EColors } from 'app/constants/colors'

const OnboardingChecklist = (props: IOnboardingChecklistProps) => {
  const { showModal, completedNumber, availableOrgFeatureNumber, windowWidth } = props
  const isMobile = windowWidth <= MAX_TABLET_DEVICE_WIDTH
  const mobileIconProps = {
    background: EColors.WHITE,
    circleborder: EColors.BLUE,
    checkcolor: EColors.BLUE,
    style: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 32,
      height: 32,
      borderRadius: 24,
      marginTop: 5,
    },
  }
  if (completedNumber === availableOrgFeatureNumber) {
    return null
  }

  if (isMobile) {
    return (
      <div
        onClick={() =>
          showModal(<OnboardingChecklistItems {...props} />, { size: 'xxs', title: 'Onboarding Checklist' })
        }
      >
        <AvailableDomain {...mobileIconProps} />
      </div>
    )
  }

  return <OnboardingChecklistItems {...props} />
}

export default OnboardingChecklist
